import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CommonButton from 'app/components/ReviewButton';
import { DATE_RANGE_KEYS } from 'app/constants/filters';
import { encodeURL } from 'app/utils/helpers';
import queryString from 'query-string';
import { useParams } from 'react-router-dom';
import { CLUSTERING } from 'store/reviewData/constants';

type ViewClusteringButtonProps = {
  trainingSessionId: number;
  mlModelId: number;
};

export const ViewClusteringButton = ({
  trainingSessionId,
  mlModelId,
}: ViewClusteringButtonProps) => {
  const { subscriptionId, packId } = useParams();

  const handleViewClusteringClick = () => {
    const params = queryString.stringify({
      contextual_filters: encodeURL({
        date: DATE_RANGE_KEYS.ALL_DATE_RANGE,
        training_ml_model__in: mlModelId,
        training_session_id: trainingSessionId,
      }),
    });
    window.open(
      `/${subscriptionId}/${packId}/annotation/${CLUSTERING}?${params}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <CommonButton
      text='View clustering'
      onClick={handleViewClusteringClick}
      variant='tertiary'
      icon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
    />
  );
};
